var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"info-icon",style:(_vm.iconStyle),on:{"click":_vm.handleClick}},[_vm._v(" i ")])
}
var staticRenderFns = []

export { render, staticRenderFns }